import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'CloseButton',
  setup(__props) {

const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

const handleButtonClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: "rounded-[0.7rem] text-sm font-bold items-center bg-jm_white py-[0.66rem] w-[18rem]",
      onClick: handleButtonClick
    }, " GOT IT ")
  ]))
}
}

})